import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AccountComponent } from './account.component';
import { FormsModule }   from '@angular/forms';
import {ClipboardModule} from "ngx-clipboard";
import { SharedModule } from '../shared/shared.module';

@NgModule({
    imports: [CommonModule, FormsModule, ClipboardModule, SharedModule ],
    declarations: [AccountComponent],
    exports: [AccountComponent]
})

export class AccountModule { }
